export const Colors = {
    success: '#4BB543',
    error: '#FF3333',
    primary: '#6366F1',
    darkGray: '#696969'
};

export const URLKeys = {
    firstMember: 'prvni_clen',
    secondMember: 'druhy_clen',
    member: 'zastupitel',
    party: 'subjekt',
    sortBy: 'razeni',
    selectedYear: 'rok',
    page: 'strana',
    rows: 'pocet_vysledku',
    voteDescription: 'popis_hlasovani',
    memberNumber: 'id_zastupitele',
    memberVote: 'hlasovani_zastupitele',
    voteResult: 'vysledek_hlasovani',
    meetingNumber: 'cislo_zasedani',
    show: 'zobrazit',
    VotingTypes:{
        secretVotes: 'tajne',
        invalidVotes: 'neplatne',
        proceduralVotes: 'proceduralni',   
    },
    voteDescriptionText: 'popis_hlasovani_text',
    fullText: 'cely_text',
};
